import { Outlet, createRootRoute } from '@tanstack/react-router';

export const Route = createRootRoute({
  component: () => (
    <div className="flex h-full w-full">
      <Outlet />
    </div>
  ),
});
